import createGetFormNames from '../selectors/getFormNames';
import immutable from '../structure/immutable';

export default createGetFormNames(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/getFormNames.js
// module id = 1198
// module chunks = 0